import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { getProjectsListApi } from '@src/api';
import { GetProjectsParams } from '@src/api/projects/projects';

const getProjectListThunk = createAsyncThunk(
  'projectList/getProjectList',
  async (params: GetProjectsParams, { rejectWithValue }) => {
    try {
      const response = getProjectsListApi(params);

      return (await response).result.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw rejectWithValue(error.response.data);
      }
      throw error;
    }
  }
);

export default getProjectListThunk;
